// extracted by mini-css-extract-plugin
export default {"footer":"App_footer__aawhi","recaptchaNotice":"App_recaptchaNotice__qZKmR"};